import MediaPlayer from "../MediaPlayer";
import m, {Vnode} from "mithril";

export default class Replay {
    constructor(
        public readonly player: MediaPlayer
    ) { }

    public view(): Vnode {
        return m('div.control.control-replay', {
                onclick: (e: MouseEvent) => {
                    this.player.replay();
                    if (this.player.isWaiting() || e.shiftKey) {
                        this.player.reload(e.shiftKey);
                    }
                },
                ondblclick: () => {
                    this.player.reload(true);
                }
            }, m('i.icon.icon-replay.text-gray')
        );
    }

}